import React from 'react'

import {
  getCarData as carData,
  getColorsData as colorsData,
  getSceneData as sceneData,
  getCarMenu as carMenu,
  getCarMenuInterior as carMenuInterior
} from '../../helpers/strapi.helper';
import { optionsData } from '../../data/options.data';

import Caracteristicas from './caracteristicas.component';
// import SettingMobile from './setting.component';
// import SettingsInterior from './settingInterior.component';
import Info from './info.component';
import GETWebParams from '../../helpers/GETWebParams';
import {IsBrowserARCompatible} from '../../helpers/IsBrowserARCompatible';
import isIOS from '../../helpers/isIOSDevice';

declare const window: any;
const params = GETWebParams()

//import arrowBtn from './../../UI/general/arrow_btn.svg'
interface CarStudioUIMobile {
  enableARGlobally: boolean,
  enableModelDownload: boolean,
}

interface Props {
  openScene: boolean,
  currentCarSelected: string,
  turnOffLights: boolean
  closeAllMenus: boolean,
  resetAllMenus: boolean,
  handleTurnOffLigths: () => void,
  handleCompleteCar: (payload: string) => void,
  handleChangeColor: (payload: string) => void,
  handleShowInterior: (payload: boolean) => void
  handleChangeSeat: (payload: string) => void
  handleChangeScene: (payload: any) => void
  handleShowBullets: (payload: boolean) => void
  handleShowBulletsInterior: (payload: boolean) => void
  handleShowVideo: (payload: boolean) => void
  showVideo: boolean,
  handleIsVideoOpened: (payload: boolean) => void
  handleSelectModel: (payload: string) => void
  handleQuotation: (payload: boolean) => void
  isQuotationOpened: boolean
  handleIsPlayingAnimation: (payload: boolean) => void
  isPlayingAnimation: boolean
  handleShowLigths: (payload: boolean) => void
  handleShowInteriorLights: (payload: boolean) => void
  handleShowPDF: (payload: boolean) => void
  currentSceneSelected: any,
  firstLoadedWebParams: boolean,
  handleFirstWebParams: (payload: boolean) => void
  handleAR: (payload: boolean) => void
  handle3DDownload: (payload: boolean) => void
  enableInternalCotizaGlobally: boolean
}
interface State {
  versionsToShow: any,
  colorsToShow: any,
  scenesData: any,
  carData: any,
  currentEditionSelected: string,
  showViews: boolean,
  showSeats: boolean,
  seatRows: number,
  showBullets: boolean,
  showLigths: boolean,
  currentSelectedVista: number,
  isCollapsed: boolean,
  currentColorSelected: string,
  optionsData: any,
  currentVersionSelected: string,
  interiorLights: boolean,
  currentSeatSelected: number,
  menuComponents: any,
  menuComponentsInterior: any,
  currentSlugSelected: string,
  showCaracteristics: boolean,
  showSettings: boolean,
  showInfo: boolean,
  showSettingsInterior: boolean,
  disableSceneButtons: boolean,
  disableColorButtons: boolean,
  disableExteriorSwitchLights: boolean,
  disableInteriorSwitchLights: boolean,
  isIOSARCapable: boolean
  isARCapable: boolean,
  enableAR: boolean,
}

class CarStudioUIMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      versionsToShow: [],
      colorsToShow: [],
      scenesData: [],
      carData: {},
      currentEditionSelected: "",
      showViews: true,
      showSeats: true,
      seatRows: 1,
      showBullets: true,
      showLigths: false,
      currentSelectedVista: 0,
      isCollapsed: true,
      currentColorSelected: '',
      optionsData: {},
      currentVersionSelected: '',
      interiorLights: false,
      currentSeatSelected: 0,
      menuComponents: [],
      menuComponentsInterior: [],
      currentSlugSelected: '',
      showCaracteristics: false,
      showSettings: false,
      showInfo: false,
      showSettingsInterior: false,
      disableSceneButtons: false,
      disableColorButtons: false,
      disableExteriorSwitchLights: false,
      disableInteriorSwitchLights: false,
      isIOSARCapable: false,
      isARCapable: false,
      enableAR: false,
    }

    this.enableARGlobally = false //allow AR feature, should be false for test and production for now
    this.enableModelDownload = false //allow download when clicked on AR, this overrides the value of enableARGlobally, should be used only for internal testing
  }

  componentDidMount(): void {
    this.setState({
      carData: carData()
    })

    if(this.enableModelDownload === true){
      this.enableARGlobally = false;
      this.setState({
        isARCapable: true
      })
    }
    
    //AR Detection
    if(this.enableARGlobally === true){
      IsBrowserARCompatible().then((value) => {
        this.setState({
          isARCapable: value
        })
      });
      this.setState({
        isIOSARCapable: isIOS()
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.currentCarSelected !== prevProps.currentCarSelected && this.props.currentCarSelected !== ''){
      this.setState({
        versionsToShow: this.state.carData[this.props.currentCarSelected],
      }, () => {
        this.setState({
          currentEditionSelected: this.props.currentCarSelected +" "+ Object.keys(this.state.versionsToShow)[0]
        }, () => {
          var colors: any = colorsData()
          var options: any = optionsData()
          var scenes: any = sceneData(this.state.currentEditionSelected)
          var menu: any =  carMenu()
          var menuInterior: any = carMenuInterior()
          var params: any = GETWebParams()
          this.props.handleCompleteCar(this.state.currentEditionSelected)
          this.setState({
            colorsToShow: colors[this.state.currentEditionSelected],
            optionsData: options[this.state.currentEditionSelected],
            menuComponents: menu[this.state.currentEditionSelected].menu,
            menuComponentsInterior: menuInterior[this.state.currentEditionSelected].menu,
            currentVersionSelected: Object.keys(this.state.versionsToShow)[0],
            showViews: this.state.versionsToShow[Object.keys(this.state.versionsToShow)[0]].showViews ?? true,
            showSeats: this.state.versionsToShow[Object.keys(this.state.versionsToShow)[0]].showSeats ?? true,
            seatRows: this.state.versionsToShow[Object.keys(this.state.versionsToShow)[0]].seatRows,
            scenesData: scenes
          }, () => {
            const sceneKeys = Object.keys(scenes);
            let defaultKey = sceneKeys.find(k => scenes[k].default === true);
            if (!defaultKey && sceneKeys.length > 0) {
              defaultKey = sceneKeys[0];
            }
            if (defaultKey) {
              this.props.handleChangeScene(scenes[defaultKey]);
            }
            this.props.handleSelectModel(Object.keys(this.state.versionsToShow)[0])
            this.setState({
              currentColorSelected: Object.keys(this.state.colorsToShow)[0]
            }, () => {
              this.props.handleChangeColor(Object.keys(this.state.colorsToShow)[0])
              if(this.enableARGlobally === true){
                this.setState({
                  isIOSARCapable: this.state.colorsToShow[this.state.currentColorSelected].usdz ? isIOS() : false
                })
              }
            })

            //WEB GET PARAMS
            if(this.props.firstLoadedWebParams === true){
              this.props.handleFirstWebParams(false)

              if(params.color !== undefined) {
                Object.keys(this.state.colorsToShow).forEach((key: any, index: number) => {
                  if( key.toLowerCase() === params.color.toLowerCase() ){
                    this.setState({
                      currentColorSelected: key
                    }, () => {
                      this.props.handleChangeColor(this.state.currentColorSelected)
                      window.sendDataByUrlParams("COLOR", this.props.currentCarSelected, this.state.currentVersionSelected, params.color.toUpperCase())
                    })
                  }
                })
              }

              if(params.scenario !== undefined) {
                Object.keys(this.state.scenesData).forEach((key: any, index: number) => {
                  if( key.toLowerCase() === params.scenario.toLowerCase() ){
                    //this.props.handleChangeScene(index)
                    //can't send update until dome is first loaded...
                    var interval : any;
                    interval = setInterval( () => {
                      if(this.props.openScene){
                        this.props.handleChangeScene(this.state.scenesData[key])
                        window.sendDataByUrlParams("ESCENARIO", this.props.currentCarSelected, this.state.currentVersionSelected, params.scenario.toUpperCase())
                        clearInterval(interval)
                      }
                    }, 100)
                  }
                })
              }

            }
            
          })
        })
      })
    }
    if(prevProps.closeAllMenus !== this.props.closeAllMenus){
      this.handleCloseAllMenus();
    }
    if(prevProps.openScene !== this.props.openScene){
      this.setState({
        isCollapsed: false
      })
    }
  }


  handleOpenMenu = (payload: string) => {
    this.setState({
      showCaracteristics: payload === 'caracteristicas' ? !this.state.showCaracteristics:false,
      showSettings: payload === 'ajustes' ? !this.state.showSettings: false,
      showInfo: payload === 'info' ? !this.state.showInfo: false,
      showSettingsInterior: payload === 'ajustes-interior' ? !this.state.showSettingsInterior: false
    }, () => {
      if(payload === 'luces' || payload === 'luces-interior'){
        this.props.handleTurnOffLigths()
      }else if(payload === 'ar'){
        if(this.enableModelDownload === true){
          this.props.handle3DDownload(true)
        }else  if(this.state.isIOSARCapable === false){
          this.props.handleAR(true)
        }
      }
      else if(this.props.turnOffLights){
        this.props.handleTurnOffLigths()
      }
    })
  }

  handleChangeColor = (payload: string) => {
    this.props.handleChangeColor(payload)
    this.setState({
      currentColorSelected: payload
    }, () => {
      if(this.enableARGlobally === true){
        this.setState({
          isIOSARCapable: this.state.colorsToShow[this.state.currentColorSelected].usdz ? isIOS() : false
        })
      }
    })
  }

  handleCloseAllMenus = () => {
    this.setState({
      showCaracteristics: false,
      showSettings: false,
      showInfo: false,
      showSettingsInterior: false,
      currentSlugSelected: ''
    })
  }

  handleChangeMenu = (payload: number) => {
    this.setState({
      currentSelectedVista: payload
    }, () => {
      this.handleCloseAllMenus()
    })
  }

  handleChangeSeat = (payload: number) => {
    this.setState({
      currentSeatSelected: payload
    }, () => {
      if(payload === 0){
        this.props.handleChangeSeat('FL')
      }
      if(payload === 1){
        this.props.handleChangeSeat('FR')
      }
      if(payload === 2){
        this.props.handleChangeSeat('BL')
      }
      if(payload === 3){
        this.props.handleChangeSeat('BR')
      }
      if(payload === 4){
        this.props.handleChangeSeat('BL2')
      }
      if(payload === 5){
        this.props.handleChangeSeat('BR2')
      }
      this.handleCloseAllMenus()
    })
  }

  handleEnableAR = () => {
    this.setState({
      enableAR: true
    })
    setTimeout(() => {
      this.setState({
        enableAR: false
      })
    }, 100);
  }

  render(): React.ReactNode {
    return(
      <React.Fragment>
        <div 
        className={this.props.showVideo ? 'car-studio-main-container-mobile fade-out':'car-studio-main-container-mobile fade-in'}
        style={{
          animation: this.props.openScene ? '0.4s moveTop linear forwards':'none',
          animationDelay: '0.4s'
        }}
        >

          <Caracteristicas
            showCaracteristics = {this.state.showCaracteristics}
            showViews = {this.state.showViews}
            showSeats = {this.state.showSeats}
            versionsToShow={this.state.versionsToShow}
            currentVersionSelected = {this.state.currentVersionSelected}
            currentCarSelected = {this.props.currentCarSelected}
            resetMenus = {this.props.resetAllMenus}
            handleChangeMenu = {this.handleChangeMenu}
            handleShowInterior = {this.props.handleShowInterior}
            handleShowBulletsInterior = {this.props.handleShowBulletsInterior}
            handleShowBullets = {this.props.handleShowBullets}
            isPlayingAnimation = {this.props.isPlayingAnimation}

            colorsToShow={this.state.colorsToShow}
            currentColorSelected={this.state.currentColorSelected}
            handleChangeColor = {this.handleChangeColor}
            currentSeatSelected={this.state.currentSeatSelected}
            handleChangeSeat={this.handleChangeSeat}
            seatRows = {this.state.seatRows}
            scenesData={this.state.scenesData}
            handleChangeScene = {this.props.handleChangeScene}
            currentSceneSelected = {this.props.currentSceneSelected}
            handleCloseAllMenus = {this.handleCloseAllMenus}
          />

          <Info
            showInfo = {this.state.showInfo}
            optionsData={this.state.optionsData}
            currentSelectedVista={this.state.currentSelectedVista}
            currentEditionSelected = {this.state.currentEditionSelected}
            handleShowVideo = {this.props.handleShowVideo}
            showVideo =  {this.props.showVideo}
            handleIsVideoOpened = {this.props.handleIsVideoOpened}
            handleQuotation = {this.props.handleQuotation}
            isQuotationOpened = {this.props.isQuotationOpened}
            isPlayingAnimation = {this.props.isPlayingAnimation}
            handleShowPDF = {this.props.handleShowPDF}
            enableInternalCotizaGlobally = {this.props.enableInternalCotizaGlobally}
            handleCloseAllMenus = {this.handleCloseAllMenus}
          />

          {/* <SettingsInterior
            showSettingInterior = {this.state.showSettingsInterior}
            currentSeatSelected={this.state.currentSeatSelected}
            handleChangeSeat={this.handleChangeSeat}
            seatRows = {this.state.seatRows}
            scenesData={this.state.scenesData}
            handleChangeScene = {this.props.handleChangeScene}
            isPlayingAnimation = {this.props.isPlayingAnimation}
            resetMenus = {this.props.resetAllMenus}
            currentSceneSelected = {this.props.currentSceneSelected}
          />

          <SettingMobile
            showSettings = {this.state.showSettings}
            colorsToShow={this.state.colorsToShow}
            scenesData={this.state.scenesData}
            currentColorSelected={this.state.currentColorSelected}
            resetMenus = {this.props.resetAllMenus}
            handleChangeColor = {this.handleChangeColor}
            handleChangeScene = {this.props.handleChangeScene}
            currentSceneSelected = {this.props.currentSceneSelected}
          /> */}

          <div className='car-studio-lower-level-container-mobile'>
            {
              this.state.menuComponents.length > 0 && this.state.currentSelectedVista === 0 ?
              this.state.menuComponents.map((menuelement: any, index: number) => 
                ( (params.lite !== "true" && (menuelement.slug !== 'ar' || this.state.isARCapable || this.state.isIOSARCapable)) || (params.lite === "true" && menuelement.slug !== 'luces' && menuelement.slug !== 'ar' && menuelement.slug !== 'info') ) ?
                <div 
                className={this.state.currentSlugSelected === menuelement.slug ? 'menu-item-container-mobile menu-item-mobile-selected':'menu-item-container-mobile'}
                key={menuelement.slug + index}
                onClick={() => {
                  if(menuelement.slug !== 'luces'){
                    this.setState({currentSlugSelected: menuelement.slug === this.state.currentSlugSelected ? '': menuelement.slug}, () => {
                      this.handleOpenMenu(menuelement.slug)
                    })
                  }else if(!this.state.disableExteriorSwitchLights && !this.props.isPlayingAnimation){
                    this.setState({disableExteriorSwitchLights: true,currentSlugSelected: menuelement.slug === this.state.currentSlugSelected ? '': menuelement.slug}, () => {
                      this.handleOpenMenu(menuelement.slug)
                    })
                    setTimeout(() => {
                      this.setState({
                        disableExteriorSwitchLights: false,
                      })
                    }, 2100);
                  }
                }}
                >
                  {
                    (this.state.isIOSARCapable && menuelement.slug === 'ar' && this.state.currentColorSelected && this.state.colorsToShow[this.state.currentColorSelected]) ? 
                    <a rel="ar" id="ar-link" href={this.state.colorsToShow[this.state.currentColorSelected].usdz}>
                      <img src={menuelement.icon.default} alt=''/>
                    </a>
                    :
                    <img src={menuelement.icon.default} alt=''/>
                  }
                </div> : null
                
                
              ):null
            }
            {
              this.state.menuComponentsInterior.length > 0 && this.state.currentSelectedVista === 1 ?
              this.state.menuComponentsInterior.map((menuelement: any, index: number) => 
                ( (params.lite !== "true" || (params.lite === "true" && menuelement.slug !== 'luces-interior' && menuelement.slug !== 'info') ) ) ?
                <div 
                className={this.state.currentSlugSelected === menuelement.slug ? 'menu-item-container-mobile menu-item-mobile-selected':'menu-item-container-mobile'}
                key={menuelement.slug + index}
                onClick={() => {
                  if(menuelement.slug !== 'luces-interior'){
                    this.setState({currentSlugSelected: menuelement.slug === this.state.currentSlugSelected ? '': menuelement.slug}, () => {
                      this.handleOpenMenu(menuelement.slug)
                    })
                  }else if(!this.state.disableInteriorSwitchLights && !this.props.isPlayingAnimation){
                    this.setState({disableInteriorSwitchLights: true, currentSlugSelected: menuelement.slug === this.state.currentSlugSelected ? '': menuelement.slug}, () => {
                      this.handleOpenMenu(menuelement.slug)
                    })
                    setTimeout(() => {
                      this.setState({
                        disableInteriorSwitchLights: false,
                      })
                    }, 2100);
                  }
                }}
                >
                  <img src={menuelement.icon.default} alt=''/>
                </div> : null
              ):null
            }
            
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default CarStudioUIMobile